import React from "react";
import "./DeceasedPill.scss";
import { isOn } from "../../utils";

export const isDeceased = (investor) => Boolean(investor) && isOn(investor.DECEASED);

const DeceasedPill = ({investor}) => (isDeceased(investor) ? <span className="DeceasedPill">Deceased</span> : null);

export default DeceasedPill;
